import React from "react";
import { useNavigate, Link } from "react-router-dom";

const ForbiddenPage = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  return (
    <>
      <div className="flex justify-center flex-col items-center h-screen">
        <h1 className="font-bold">
          Forbidden Access! You are not authorised to see this page! 403
        </h1>
        <p>
          <Link
            className="underline"
            to={
              role === "investor"
                ? "/investor/dashboard"
                : "/business/dashboard"
            }
          >
            Back to dashboard!
          </Link>
        </p>
      </div>
    </>
  );
};

export default ForbiddenPage;
